export const REG_EXP = {
  NUMBERS: /^[0-9]*$/, // numbers one or more times
  NUMBER_FIXED_LENGTH_8: /^[0-9]{8}$/, // exactly 8 numbers
  NUMBER_FIXED_LENGTH_13: /^[0-9]{13}$/, // exactly 13 numbers
  ORDER_ID: /^(\\w{8})(-(\\w{4})){3}-(\\w{12})$/, // 2ca9dff9-d414-4f52-a248-bea6389a7631 - 32 alphanumeric with - in between
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/, // only alphanumeric characters
  LETTERS_NUMBERS_SPACE: /^[A-Za-z0-9 _\\s]*[A-Za-z0-9][A-Za-z0-9 _\\s]*$/, // only letters, numbers and space
  PHONE_NUMBER: /^[0-9- ()+]{9,23}$/,
  CANADA_TRAVEL_NUMBER: /^((CAN)|(can))([a-zA-Z0-9]{10,})$/,
  ALPHANUMERIC_FIXED_LENGTH_6: /^[a-zA-Z0-9]{6}$/, // only alphanumeric with 6 characters
  NUMBER_FIXED_LENGTH_10: /^[0-9]{10}$/, // exactly 10 numbers
  CONFIRMATION_NUMBER: /^[a-zA-Z0-9]{6,}$/, // only alphanumeric with 6 characters and above
  TICKET_NUMBER: /^[0-9]{13,14}$/, // accepts 13-14 numbers
  CREDITCARD_NUMBER: /^[0-9]{10,16}$/, // accepts numbers with ten digits and above
  NON_NUMERIC: /^([^0-9]*)$/, // restricts numbers
  INPUT_NAME_50: /^[a-zA-Z][a-zA-Z&-'\s]{0,49}$/, // only letters and space with less than 50 characters
  TRAVEL_NUMBER: /^[a-zA-Z0-9]*$/i, //accept only alphanumeric - case insentive
  CANADIAN_TRAVEL_NUMBER: /^[Cc][Aa][Nn][0-9]{10}$/i, //accept letters(CANcan) and 10 digits - case insentive
  CITY_NAME: /^[a-zA-Z\s\-'.]{3,}$/i, //accept letters and few symbols with 3 and above characters
  STREET_NAME: /^[a-zA-Z0-9\s'.-]*$/i, //accept alphanumerics and few symbols
  ZIP_CODE: /^.{2,12}$/i, //accept min 2 and max 12 characters
  NAME: /^(?!.*'')(?!.*--)[a-zA-Z\s\-']*$/i, // accept letters and few symbols
  EMERGENCY_PHONE_NUMBER: /^[\d\s-.]{6,13}$/i, //accept 6 to 13 number of digits
  PASSENGER_PHONE: /^[\d\s-.]{6,13}$/i, //accept phone number
  EMAIL_ADDRESS: /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/i, // email address format
  PHONE_STRING_ID: /(?:)phone($)*[0-9]/, // phone ID form control
  EMAIL_STRING_ID: /(?:)email($)*[0-9]/, // email ID form control
  ALPHABETS: /^[a-zA-Z]+$/, // only alphabetic characters
  SKYBONUS_NUMBER: /^(?=.{3,11}$)[a-zA-Z]{2}[0-9]+$/, // Skybonus number format
  UK_PHONE_NUMBER: /^([\d]){5}[\s]{1}([\d]){6}$/, // United Kingdom phone number
  US_PHONE_NUMBER: /^[0-9()/+-]{4,22}$/, // United state phone number
  USER_ID_LENGTH: /^.{6,132}$/,
  EMAIL: /^[\w-]+(?:\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,13}$/i,
  TWITTER: /^[A-Za-z0-9\\_]+$/,
  ADDRESS_NICKNAME: /^[a-zA-Z0-9 ]{0,50}$/,
  PROFILE_NAME: /^([a-zA-Z][a-zA-Z\-\\'\s]*|)$/,
  PROFILE_PHONE_NUMBER: /^[0-9- ()+]{6,15}$/,
  PREFERRED_NAME: /^([a-zA-Z][a-zA-Z\s'\-&]*|)$/,
  PROFILE_EXTENSION: /^[0-9]{0,5}$/,
  PASSPORT: /^[*a-zA-Z0-9]+$/i,
  REDRESS_NUMBER: /^[0-9]{7}$/,
  KTN_NUMBER: /^[a-zA-Z0-9]{8,25}$/,
  CANADIAN_NUMBER: /^CAN[a-zA-Z0-9]{10}$/,
  CITY: /^([a-zA-Z\s]*|)$/,
  ADDRESS: /^[a-zA-Z0-9 ]{0,40}$/
};
